var map = {
	"./bkg-footer.svg": 81786,
	"./site-logo-desktop-footer.svg": 51954,
	"./site-logo-desktop.svg": 25890,
	"./site-logo-drawer-mobile.svg": 86776,
	"./site-logo-drawer.svg": 30749,
	"./site-logo-mobile-drawer.svg": 98338,
	"./site-logo-mobile.svg": 96544,
	"./site-logo-sm.svg": 52538,
	"./site-logo-wrapper-mobile-scrolled.svg": 44683,
	"./site-logo-wrapper-mobile.svg": 72498,
	"./site-logo-wrapper-scrolled.svg": 57564,
	"./site-logo-wrapper.svg": 35155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30698;